import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AlertSupportComponent } from '../alert-support/alert-support.component';
import { AppState } from '../app.service';
import { Client } from '../client/client.model';
import mixpanel from 'mixpanel-browser';
import { Router } from '@angular/router';
import { ModalController, Platform } from '@ionic/angular';
import { I18n } from '../i18n.service';
import { HomeUiService } from '../new-design/home-ui.service';
import { TranslateComponentModalComponent } from '../components/translate-component-modal/translate-component-modal.component';
import { LANGUAGES } from '../components/translate-component-modal/translate.data';
@Component({
  selector: 'common-header',
  templateUrl: './common-header.component.html',
  styleUrls: ['./common-header.component.scss'],
})
export class CommonHeaderComponent implements OnInit {

  client: Client
  @Input() public showEdit: boolean = false;
  @Input() headerName: any
  animationState = false;
  selectedLanguage;
  availableLanguages = LANGUAGES;
  pathLanguage = 'en';
  isCommunityHeader;
  path;
  isMobile;
  @Output() animationStateChange = new EventEmitter()
  @Output() languageSelected = new EventEmitter<any>();
  constructor(
    private dialog: MatDialog,
    private appState: AppState,
    public platform: Platform,
    private route: Router,
    private i18n: I18n,
    private homeUIService: HomeUiService,
    private modalController: ModalController
  ) {
    this.client = this.appState.get('currentClient');
    this.isMobile = this.appState.get('isMobile');
  }

  ngOnInit() {
    this.path = this.appState.get("currentPath");
    this.selectedLanguage = this.appState.get('selectedLanguage')?true:false
    this.pathLanguage = this.path.language
    if (this.headerName) {
      this.isCommunityHeader = this.headerName =='Community'
     this.headerName = this.i18n.t(`${this.headerName}`)
    }
   }

  goToQuestion() {
    var supportDialog = this.dialog.open(AlertSupportComponent);
    supportDialog.afterClosed().subscribe()
  }
  trackMenuClick(value: string, event: any) {
    console.log("evennt", event)
    mixpanel.track('Home-Menu Click', { 'pageName':value, 'url': event.target.href });
  }
  close(){
    this.homeUIService.getLastModal();
    this.modalController.dismiss();
 
  }

  async openTranslateModal() {
    const modal = await this.modalController.create({
      component: TranslateComponentModalComponent,
      componentProps: {
        languages: this.availableLanguages.filter(([code]) => code !== this.pathLanguage),
        pathLanguage: this.availableLanguages.find(([code]) => code === this.pathLanguage)
      },
      cssClass: this.isMobile ? 'mobile-custom-to_do_list-forms mobile_language_translate_modal' : 'web_feedbackForm_modal web_language_translate_modal',
      animated: false
    });
    modal.onDidDismiss().then((result) => {
      if (result.role === 'backdrop') {
        mixpanel.track("User closed the modal by clicking on backdrop before saving language");
      } else if (result.data) {

        //const selected = result.data && result.data !== 'none' ? result.data : 'none';
        const selected= this.appState.get("selectedLanguage")
        if (this.selectedLanguage != selected) {
          // this.appState.set("isNewLanguageSelected", true)
          this.selectedLanguage =  this.appState.get("selectedLanguage") ? true : false;
          this.languageSelected.emit(selected);
        }
      }
    });
    await modal.present();
    
  }
}
